import { styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { ProjectSetting } from '../../types';
import { Project, ProjectStatus } from '../../types/Project';
import StatusLabel from '../../components/StatusLabel';
import getProjectStatus from '../../utils/common';
import { format } from 'date-fns';

const Container = styled(Link)`
  display: grid;
  align-items: center;
  min-height: 72px;
  font-size: 1rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.secondary.$100};
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  padding: 11px 24px 11px 16px;
  margin: 8px 0;
  gap: 24px;
  text-decoration: none;
  grid-template-columns: 30px 1fr 1fr 150px;

  & > div {
    &:first-of-type {
      min-width: 30px;
      font-weight: 500;
      text-align: center;
    }
    &:nth-of-type(2) {
      max-width: 150px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &:nth-of-type(3) {
      margin-left: auto;
    }
    &:nth-of-type(4) {
      margin-left: auto;
    }
  }
`;

interface ProjectProps {
  order: number;
  project: Project;
  projectSetting?: ProjectSetting;
}
const now = new Date();

const ProjectItem: React.FC<ProjectProps> = ({ order, project }) => {
  const startDate = new Date(project.startDate);
  const endDate = new Date(project.endDate);
  let status: ProjectStatus = 'open';

  status = getProjectStatus({
    status: 'ACTIVE',
    now,
    startDate,
    endDate,
    archived: project.archived,
  });

  return (
    <Container to={`${project.id}/info`}>
      <div>{order}</div>
      <div className="project-name" title={project.name}>
        {project.name}
      </div>

      <StatusLabel status={status}>{status.toUpperCase()}</StatusLabel>
      <div>{format(project.createdAt, 'yyyy-MM-dd HH:mm:ss')}</div>
    </Container>
  );
};

export default ProjectItem;
